const CiecStatus = Object.freeze({
  PENDING: 10,
  VALID: 20,
  INVALID: 30,
  DEACTIVATED: 40,
  ERROR: 50
})

module.exports = CiecStatus
